// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-button-docs',
    templateUrl: './button.docs.generated.html',
})
export class UIButtonDocs { }
